import { useEffect, useState, useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";
import Spinner from "../Spinner/Spinner";
import {
  getOfflineStatus,
  subscribeOfflineStatus,
} from "../../offline/offlineSync";
import "./SyncStatus.scss";

/**
 * Shows when the app is offline, a "Syncing" overlay while changes made
 * offline are sent, and a notice if some of them couldn't be saved
 */
function SyncStatus() {
  const { t } = useTranslation();
  const { online, syncing, pending, failed } = useSyncExternalStore(
    subscribeOfflineStatus,
    getOfflineStatus,
  );
  const [showFailed, setShowFailed] = useState(false);

  useEffect(() => {
    if (syncing || !failed) return;
    setShowFailed(true);
    const timer = setTimeout(() => setShowFailed(false), 8000);
    return () => clearTimeout(timer);
  }, [syncing, failed]);

  if (syncing) {
    return (
      <div className="sync-status-overlay">
        <Spinner text={t("sync.syncing")} />
      </div>
    );
  }

  if (!online) {
    return (
      <div className="sync-status-badge">
        <span className="material-symbols-outlined">cloud_off</span>
        <span>
          {pending > 0
            ? t("sync.offlinePending", { count: pending })
            : t("sync.offline")}
        </span>
      </div>
    );
  }

  if (showFailed) {
    return (
      <div className="sync-status-badge sync-status-badge--error">
        <span className="material-symbols-outlined">error</span>
        <span>{t("sync.failed", { count: failed })}</span>
      </div>
    );
  }

  return null;
}

export default SyncStatus;
